module.exports = __webpack_public_path__ + "img/CAL-IEC-Accessory.da80b7dd.png";